import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { getQueryStringValue } from '~/modules/analytics/gtmEventTypes/gtmEventTypeHelper';
import { GA4HeaderNavLinkClickEvent, GTMBaseEvent, GtmEventType } from './gtmEventType';

export type HeaderNavLinkClickAnalyticsEvent = {
    headerNavLink: {
        label: string;
        navItem: string;
        url: string;
        level: string;
    };
} & GTMBaseEvent;

export class GtmHeaderNavLinkClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.elementType === 'headerNavLink';
    }

    getBody(event: HeaderNavLinkClickAnalyticsEvent): GA4HeaderNavLinkClickEvent {
        const { label, navItem, url, level } = event.headerNavLink;
        return {
            event: 'custEv_navigationClick',
            nav_level: level,
            nav_item: navItem,
            click_text: label,
            click_url: url,
            internal_driver: getQueryStringValue(url, 'd'),
            element_type: 'link',
            nav_type: 'global',
        };
    }
}
